// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__3U63n","inputWrap":"Table_inputWrap__3qJJu","col":"Table_col__G-YqL","bmiTooltip":"Table_bmiTooltip__21nAc"};